var AudioManager = {
	
	sounds:{},
	lastUrl:"",

	load :function(url) {
		if (!AudioManager.sounds.hasOwnProperty(url)) {
			AudioManager.sounds[url] = new AudioPlayer("speechtip");
			AudioManager.sounds[url].loadSound(url);
		}
	},

	play:function(url, vol) {
		if (this.lastUrl != url && this.lastUrl != "" && AudioManager.sounds[this.lastUrl] != undefined) {
			AudioManager.sounds[this.lastUrl].stop();
		}

		if (AudioManager.sounds.hasOwnProperty(url)) {
			AudioManager.sounds[url].playWhenLoaded();
			AudioManager.sounds[url].setVolume(vol);
		} else {
			AudioManager.load(url);
			AudioManager.sounds[url].playWhenLoaded();
			AudioManager.sounds[url].setVolume(vol);
		}

		this.lastUrl = url;
		return AudioManager.sounds[url];
	},

	player: function(url) {
		return AudioManager.sounds[url];
	},

	setAllVolumes: function(v) {
		for(var s in AudioManager.sounds) {
			AudioManager.sounds[s].setVolume(v);
		}
	}
}